module.exports = __webpack_public_path__ + "img/sort - up.b0b55f21.svg";